import { render, staticRenderFns } from "./personConf.vue?vue&type=template&id=4b674d5c&scoped=true&"
import script from "./personConf.vue?vue&type=script&lang=js&"
export * from "./personConf.vue?vue&type=script&lang=js&"
import style0 from "./personConf.vue?vue&type=style&index=0&id=4b674d5c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b674d5c",
  null
  
)

/* custom blocks */
import block0 from "./personConf.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports